// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// ValidateNewProgramChangeRequestStep11Handler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import NewProgramProgramAwardDTO from '../models/NewProgramProgramAwardDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    totalCredits: number;
    totalTechCoreCredits: number;
    changeRequestId: string | null;
    programAward: NewProgramProgramAwardDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            totalCredits: 0,
            totalTechCoreCredits: 0,
            changeRequestId: '00000000-0000-0000-0000-000000000000',
            programAward: null,
        },
        initValues);
    },
    totalCredits: 'totalCredits',
    totalTechCoreCredits: 'totalTechCoreCredits',
    changeRequestId: 'changeRequestId',
    programAward: 'programAward',
}

interface Result extends ResultDTO {
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
        },
        initValues);
    },
}

export { Request, Result };